import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import RegionSelector from '../../FormElements/regionSelector/RegionSelector'
import ChapterSelector from '../../FormElements/chapterSelector/ChapterSelector'
import CaseNumberSelector from '../../FormElements/caseSelector/CaseNumberSelector'
import CaseTitleSelector from '../../FormElements/caseSelector/CaseTitleSelector'
import DateFilter from '../../FormElements/dateFilter/DateFilter'
import PartySelector from '../../FormElements/partySelector/PartySelector'
import ActionButtons from '../../FormElements/actionButtons/ActionButtons'
import Collapsible from '../../../common/Collapsible'
import AlertError from '../../../common/AlertError'
import { receiveError } from '../../../../redux/actions/pacerSearch.js'
import { validateInputs } from '../inputValidations'
import validations from '../../validations'

import * as errorConstants from '../../../../constants/errorConstants'

class CriminalSearchForm extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dateCollapsed: true
        }
    }

    changeSearchType = (e) => {
        this.props.actions.resetSearchResults()
        this.setState({selectedSearchType: e.target.value})
    }


    dateCollapseChanged = (collapsible) => {
        this.setState({dateCollapsed: collapsible.isCollapsed})
    }

    validateInputs = (filtersMap) => {
        const filters = filtersMap.toJS()
        if (!client_code_is_valid()) return {messages: ["Please set a valid client code first."]};

        const messages = [];
        const fields = [];

        if (filters.party_name && ! validations.PARTY_NAME_CASE_TITLE(filters.party_name)) {
            messages.push('Invalid party name.')
            fields.push('party_name')
        }

        if (filters.case_title && ! validations.PARTY_NAME_CASE_TITLE(filters.case_title)) {
            messages.push('Invalid case title.')
            fields.push('case_title')
        }

        if (filters.case_no && ! validations.CASE_NUMBER(filters.case_no)) {
            messages.push('Invalid case number format.')
            fields.push('case_no')
        }

        const desired_fields = ['case_no', 'case_title', 'party_name', 'filed_from', 'filed_to', 'closed_from', 'closed_to'];
        const fieldNotEmpty = (fieldName) => !!filters[fieldName];
        if (!desired_fields.find(fieldNotEmpty)) {
            return {
                messages: [
                    "Please enter at least one search parameter:",
                    "- Case number",
                    "- Case title",
                    "- Party name",
                    "- Date Field",
                ],
                fields: desired_fields
            }
        }


        return (!_.isEmpty(messages))
            ? {messages: messages, fields: fields}
            : null
    }

    searchClickHandler = () => {
        const validationErrors = this.validateInputs(this.props.filters)
        if (validationErrors) {
            this.props.dispatch(receiveError(errorConstants.VALIDATION_ERROR, validationErrors))
        } else {
            this.props.actions.searchCriminal(this.props.filters)
        }
    }

    render() {
        const formElemProps = Object.assign({}, {...this.props}, {onChange: this.props.updateFilter})

        return (
            <div className="search-form-container">
                <fieldset className="ir-search-double">
                    <RegionSelector {...formElemProps} />
                </fieldset>

                <CaseNumberSelector {...formElemProps} />
                <CaseTitleSelector {...formElemProps} />

                <Collapsible title="Date Filters"  onChange={this.dateCollapseChanged}>
                    <DateFilter {...formElemProps} name="filed" />
                    <DateFilter {...formElemProps} name="closed" />
                </Collapsible>

                <PartySelector {...formElemProps} tooltipClassName={`party-tooltip${!this.state.dateCollapsed ? ' top-55' : ''}`} />

                <ActionButtons {...formElemProps} searchClickHandler={this.searchClickHandler} />

                <AlertError />
            </div>
        )
    }

    componentDidMount = () => {
        if (this.props.immediateSearch) {
            this.searchClickHandler()
        }
    }
}

const mapStateToProps = state => ({immediateSearch: state.get('immediateSearch')})

export default connect(mapStateToProps)(CriminalSearchForm)



/** WEBPACK FOOTER **
 ** ./src/components/search/forms/criminalSearchForm/CriminalSearchForm.js
 **/